import * as Models from "../../ts/rlAdmin.models";
import * as Utils from "../../ts/rlAdmin.utils";
import * as Consts from "../../ts/rlAdmin.consts";
import { NotifyService } from "../../services/notify-service";
import { SearchService } from "../../services/search-service";

export class DebugQueryNodeController {
    static $inject = ["$filter", "notifyService", "searchService"];

    charTypeID: number;
    queryValues: Models.IKeyValuePair<string, string>[];
    queryText: string;

    constructor(private $filter: ng.IFilterService, private notifyService: NotifyService, private searchService: SearchService) {

        this.charTypeID = 1;
        this.queryText = "";
        this.queryValues = [];
    }

    Clear() {
        this.charTypeID = 1;
        this.queryText = "";
        this.queryValues = [];
    }

    Send() {
        try {
            var queryNode = <Models.IQueryNode>JSON.parse(this.queryText);

            this.notifyService.startProgress();
            this.searchService.debugQueryNode(this.charTypeID, queryNode)
                .then(results => {
                    this.queryValues = results.data;
                })
                .finally(() => {
                    this.notifyService.endProgress();
                });
        }
        catch (err) {
            alert(err);
        }

    }

    Format() {
        try {
            var json = JSON.parse(this.queryText);
            this.queryText = this.$filter("json")(json);
        }
        catch (err) {

        }
    }
}
